import 'vant/lib/index.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Button,DropdownMenu,DropdownItem,Cell,Switch,Field} from 'vant'
import { RadioGroup, Radio } from 'vant';
import { CheckboxGroup, Checkbox } from 'vant';
import { Tab, Tabs } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { NavBar, Icon, Tag, Card, Divider } from 'vant';
import { Toast } from 'vant';
import { Empty } from 'vant';

import axios from "axios";

Vue.prototype.$http = axios;
import storage from './assets/js/storage.js'
Vue.prototype.$storage = storage
import { setCookie, getCookie, delCookie } from "./assets/js/cookies.js";
Vue.prototype.setCookie = setCookie;
Vue.prototype.getCookie = getCookie;
Vue.prototype.delCookie = delCookie;


axios.interceptors.request.use(
  (config) => {
      if (getCookie("loginid")) {
          // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
          config.headers.numbers = getCookie("jid");
          config.headers.token = getCookie("loginid");
      }
      return config;
  },
  (err) => {
      return Promise.reject(err);
  }
);

// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
  (response) => {
      //  console.log(response.data.code );
      if (response.data.code == 403) {
        
        Vue.prototype.$toast.fail('请重新登录') ;
        Vue.prototype.delCookie("loginid");
        //跳转到登录页面
        window.location.href = "//custom.netban.cn/app/login.html";
        // router.replace({
        //     path: "/",
        // });
        return;
      }else{
        return response;
      }
 
    
  },
  (error) => {
      if (error.response) {
          switch (error.response.status) {
              case 200:
                  console.log(error.response);
                  Vue.prototype.$message.warning("请重新登录");
                  break;
              case 401:
                  // 这里写清除token的代码
                  Vue.prototype.$message.warning("请重新登录");
                  Vue.prototype.delCookie("loginid");
                  router.replace({
                      path: "/",
                  });
                  break;

              case 500:
                  Vue.prototype.$message.warning("网络错误，请重试");
                  break;
          }
      }
      return;
  }
);
Vue.prototype.api = process.env.VUE_APP_API;

Vue.component('van-field', Field)
Vue.component('van-button', Button)
Vue.component('van-dropdown-menu', DropdownMenu)
Vue.component('van-dropdown-item', DropdownItem)
Vue.component('van-cell', Cell)
Vue.component('van-switch', Switch)
Vue.component('van-checkbox-group', CheckboxGroup)
Vue.component('van-checkbox', Checkbox)
Vue.component('van-radio-group', RadioGroup)
Vue.component('van-radio', Radio)
Vue.component('van-tab', Tab)
Vue.component('van-tabs', Tabs)
Vue.component('van-tabbar', Tabbar)
Vue.component('van-tabbar-item', TabbarItem)
Vue.component('van-nav-bar', NavBar)
Vue.component('van-icon', Icon)
Vue.component('van-tag', Tag)
Vue.component('van-card', Card)
Vue.component('van-divider', Divider)
Vue.use(Toast);
Vue.use(Empty);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
